import RequestAbstract from "../abstract";

export default class FeeTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/fee-transactions";
    }
}
